import { createContext } from "react";

export interface IBaseAppContext {
  auth: string;
  isLoggedIn: boolean;
  loggedUserId: string;
  loggedUserName: string;
  loggedUserRole: number;
  loggedPatientId: string;
  setContext: (data: Partial<IBaseAppContext>) => void;
  clearContext: () => void;
}

export const BaseAppContext = createContext<IBaseAppContext>({
  auth: "",
  isLoggedIn: false,
  loggedUserId: "",
  loggedUserName: "",
  loggedUserRole: 0,
  loggedPatientId: "",
  setContext: () => {},
  clearContext: () => {},
});
